import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { ApiServerService } from 'src/app/core/services/api/api-server.service';
import { Service } from 'src/app/core/services/misiones/misiones.service';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-completo',
  templateUrl: './completo.component.html',
  styleUrls: ['./completo.component.scss']
})
export class CompletoComponent implements OnInit {

  url = environment.urlBack;
  actividades: any[] = []
  state = null;
  score = null;
  description = null;
  token = null;
  ot = null;
  code = null;
  performer = null;
  section = null;
  when = null;
  ut = null;
  descripcion = null;
  esComplete = false;
  allAActivities = [];
  missionId: string | undefined;
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private serviceApi: ApiServerService,
    public dialog: MatDialog,

  ) {
    this.initializeData();
    this.missionId = this.rutaActiva.snapshot.params.mission;

  }
  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    $('.ui.accordion').accordion();
  }
  goHome() {
    this.router.navigate(['/']);
  }
  // padre.component.ts
  indiceActual = 0;

  onChildComplete(index: number) {
    // Solo incrementamos si el que terminó es el último que activamos
    if (index === this.indiceActual && this.indiceActual < this.prefijosReferencia.length - 1) {
      this.indiceActual++;
    }
  }
  instruction = '';
  prefijosReferencia: any = []
  initializeData(): void {

    $("#spinner-load").css("display", "block");
    let missionId = this.rutaActiva.snapshot.params.mission;
    this.instruction = "Evaluación completa";

    this.serviceApi.getDetail({ missionId, activity: this.instruction }).subscribe(res => {

      if (res.data) {
        this.descripcion = res.data.Protocol_Id;
        this.prefijosReferencia = res.prefijosReferencia;
        this.ot = res.data.Status.OT?.Observed;
        this.code = res.data.Status.CodigoEstacion?.Observed + " , " + res.data.Status.Description?.Observed;
        this.score = res.data.score;
        this.state = res.data.state;
        this.section = res.data.Status.Seccion?.Observed;
        this.performer = res.data.Who[0].username;
        this.ut = res.data.Status.Description.Observed;
        this.when = res.data.When;
      }

      this.actividades = res.actividades


      $('#spinner-load').css("display", "none");


    })


  }


  groupByInstructionId(data: { Instruction_Id: number }[]) {
    const groupedData = data.reduce((items, item) => {
      const key = item.Instruction_Id;

      if (!items[key]) {
        items[key] = [];
      }

      items[key].push(item);

      return items;
    }, {});

    const formattedResult = Object.entries(groupedData).map(([key, items]) => ({
      key: key,
      items,
    }));

    return formattedResult;
  }





  groupByActividad(data) {
    const key = "Activity_Dsc";
    return Object.entries(data.reduce((acc, cur) => {
      const actividad = cur[key];
      const sec = cur["Activity_Seq"];

      if (!acc[actividad]) {
        acc[actividad] = {
          key: actividad,
          sec: sec,
          results: [],
        };
      }

      const curCopy = { ...cur };
      acc[actividad].results.push(curCopy);

      return acc;
    }, {})).map(([key, value]) => value);
  }

  filtrarUltimas(preguntas: any) {
    const map = new Map<string, any>();
    preguntas.forEach(obj => {
      const compositeKey = `${obj.Instruction_Id}_${obj.Evidence_Type}`;
      const existingObj = map.get(compositeKey);
      if (!existingObj || obj.When > existingObj.When) {
        map.set(compositeKey, obj);
      }
    });
    const result = Array.from(map.values());
    return result;
  }

  ordenarPreguntas(arr: any) {
    return arr.sort((x, y) => x.Instruction_Seq - y.Instruction_Seq);
  }
  formatearNumero(respuesta) {
    if (!isNaN(respuesta)) {
      if (respuesta % 1 !== 0) {
        respuesta = Number(respuesta).toFixed(2);
      }
    }
    return respuesta;
  }

  activePanel(i) {
    console.log(i)

    if (document.getElementById("panel" + i).classList.contains("active")) {
      document.getElementById("panel" + i).classList.remove("active");
      document.getElementById("content" + i).classList.remove("active");
    } else {
      document.getElementById("panel" + i).classList.add("active");
      document.getElementById("content" + i).classList.add("active");
    }

  }
}


